import * as Loads from 'react-loads';

import { Container, ContainerGrid } from '~/components/layout/PageStructure';

import Link from '~/components/ui/Link';
import ProductGrid from '~/components/product/ProductGrid';
import ProductSlider from '~/components/product/ProductSlider';
import PropTypes from 'prop-types';
import React from 'react';
import client from '~/utils/client';
import { productFragment } from '~/utils/queries';
import { CollectionPageLoader } from '~/components/ui/molecules/skeleton-loaders/CollectionPageLoader';
import { SliderFeaturedCollectionLoader } from '~/components/ui/molecules/skeleton-loaders/SliderFeaturedCollectionLoader';

const queryRecent = `
  query($order: ProductOrder, $limit: Int!) {
    products(order: $order, first: $limit) {
      data {
        ${productFragment}
      }
    }
  }
`;

const queryCollection = `
  query($slug: String!, $order: ProductOrder, $limit: Int!) {
    collection(slug: $slug) {
      id
      slug
      products(order: $order, first: $limit) {
        data {
          ${productFragment}
        }
      }
    }
  }
`;

const fetchData = async collection => {
  const query = collection ? queryCollection : queryRecent;
  const variables = {
    order: 'FEATURED',
    limit: 12,
    ...(collection && { slug: collection }),
  };

  return await client.request(query, variables, { cache: true });
};

export const FeaturedCollection = ({ data }) => {
  const { settings = {} } = data;
  const { layout = 'grid', collection = false, title = false } = settings;

  const { response, isResolved } = Loads.useLoads(
    `${data.type}-${data.id}`,
    fetchData,
    {
      variables: [collection],
    },
  );

  return (
    <>
      <div className="py-7">
        {title && (
          <Container className="mb-6">
            <h2 className="text-h4 lg:text-h4-lg">
              <Link className="underline" to={`/collections/${collection}`}>
                {title}
              </Link>
            </h2>
          </Container>
        )}

        {layout === 'grid' && (
          <ContainerGrid className="sm:grid-cols-6">
            <CollectionPageLoader totalThumbs={15} ready={isResolved}>
              <ProductGrid
                products={
                  response?.collection?.products?.data ||
                  response?.products?.data
                }
                productClassName="col-span-2 md:col-span-3 mb-3"
              />

              {collection && (
                <div
                  className="col-span-full text-small lg:text-small-lg underline"
                  key="view-more"
                >
                  <Link to={`/collections/${collection}`}>
                    View full collection
                  </Link>
                </div>
              )}
            </CollectionPageLoader>
          </ContainerGrid>
        )}

        {layout === 'slider' && (
          <SliderFeaturedCollectionLoader ready={isResolved}>
            <ProductSlider
              layout={'contained'}
              slug={collection}
              products={
                response?.collection?.products?.data || response?.products?.data
              }
            />
          </SliderFeaturedCollectionLoader>
        )}
      </div>
    </>
  );
};

FeaturedCollection.propTypes = {
  data: PropTypes.shape({
    id: PropTypes.string,
    title: PropTypes.string,
    products: PropTypes.array,
    layout: PropTypes.string,
  }),
};
